import { useCallback, useContext } from 'react'
import { GlobalStoreContext } from 'Components/store'
import { LoginStoreContext } from 'New/login/login-store'
import { ILoginCommonParams } from 'New/login/context/view-context'

function useLoginCheckCallback<T extends (...args: any[]) => any>(
  callback: T,
  commonParams?: ILoginCommonParams
) {
  const { state: globalState } = useContext(GlobalStoreContext)
  const { openLogin } = useContext(LoginStoreContext)

  return useCallback(
    (...args) => {
      if (globalState?.userData?.user_id) {
        return callback(...args)
      } else {
        openLogin(commonParams)
      }
    },
    [globalState?.userData?.user_id, callback, commonParams, openLogin]
  )
}

export default useLoginCheckCallback
